import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS, SUPPORTED_PAGES } from "../../_builder-constants";

const TAB_SCHEMA = [
  { key: "label", label: "Tab Label", type: "string" as const },
  { key: "categoryId", label: "Category", type: "category-select" as const, help: "Empty = the newest products." },
];

export const schema: ComponentSchema = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"] as typeof SUPPORTED_PAGES[number][],
  variants: [
    {
      id: "v1",
      label: "Tabbed product grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Shop by style" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: TAB_SCHEMA },
        { key: "viewAllLabel", label: "“Explore more” button text", type: "string", default: "Explore more", help: "Links to the open tab’s category, else to the newest products." },
      ],
    },
    {
      id: "v2",
      label: "Swipe row, three across",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New in" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "" },
        { key: "launchAt", label: "Launch date (optional)", type: "string", placeholder: "2026-12-01T10:00", help: "Shows a \"Drops in…\" tag in the title row until then, \"Out now\" for a week after." },
      ],
    },
    {
      id: "v3",
      label: "Swipe row, four across",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Launches" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "" },
        { key: "launchAt", label: "Launch date (optional)", type: "string", placeholder: "2026-12-01T10:00", help: "Shows a \"Drops in…\" tag in the title row until then, \"Out now\" for a week after." },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
